import { Directive, ElementRef, Renderer2, Optional, OnInit, OnDestroy } from '@angular/core';
import { NgControl } from '@angular/forms';
import { Subscription, merge } from 'rxjs';

@Directive({
  selector: '[error]',
})
export class ErrorDirective implements OnInit, OnDestroy {
  private sub!: Subscription;
  private errorDiv!: HTMLElement;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    @Optional() private controlDir: NgControl
  ) {}

  ngOnInit() {
    if (!this.controlDir) return;

    const control = this.controlDir.control;
    if (!control) return;

    this.createErrorDiv();

    // Subscribe to valueChanges and statusChanges to update UI and errors
    this.sub = merge(control.statusChanges!, control.valueChanges!).subscribe(() => {
      this.updateUI(control);
    });

    this.updateUI(control);
  }

  private createErrorDiv(): void {
    this.errorDiv = this.renderer.createElement('div');
    this.renderer.addClass(this.errorDiv, 'text-red-600');
    this.renderer.addClass(this.errorDiv, 'text-sm');
    this.renderer.setStyle(this.errorDiv, 'margin-top', '0.25rem');

    const parent = this.renderer.parentNode(this.el.nativeElement);
    this.renderer.appendChild(parent, this.errorDiv);
  }

  private updateUI(control: any): void {
    const errors = control.errors;
    const isTouchedOrDirty = control.touched || control.dirty;

    let errorMessage = '';

    if (errors) {
      if (errors['required']) {
        errorMessage = 'This field is required.';
      } else if (errors['email']) {
        errorMessage = 'Please enter a valid email address.';
      } else if (errors['apiError']) {
        errorMessage = errors['apiError'];
      }
    }

    const showError = errorMessage && isTouchedOrDirty;

    if (showError) {
      // Show red border and focus styles
      this.renderer.addClass(this.el.nativeElement, 'border');
      this.renderer.addClass(this.el.nativeElement, 'border-red-500');
      this.renderer.addClass(this.el.nativeElement, 'focus:border-red-500');
      this.renderer.addClass(this.el.nativeElement, 'focus:ring-red-500');

      // Show error message text
      this.renderer.setProperty(this.errorDiv, 'textContent', errorMessage);
      this.renderer.setStyle(this.errorDiv, 'display', 'block');
    } else {
      // Remove error styles
      this.renderer.removeClass(this.el.nativeElement, 'border');
      this.renderer.removeClass(this.el.nativeElement, 'border-red-500');
      this.renderer.removeClass(this.el.nativeElement, 'focus:border-red-500');
      this.renderer.removeClass(this.el.nativeElement, 'focus:ring-red-500');

      // Hide error message
      this.renderer.setStyle(this.errorDiv, 'display', 'none');
    }
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
    if (this.errorDiv) {
      this.renderer.removeChild(this.renderer.parentNode(this.el.nativeElement), this.errorDiv);
    }
  }
}
